const Radio = {
  defaultProps: {
    colorScheme: 'primaryScale'
  }
};

export default Radio;
